import { CustomTheme, styled, useStyletron } from '@tigergraph/app-ui-lib/Theme';
import { Check } from 'baseui/icon';
import React from 'react';

const StepperContainer = styled('div', {
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
});

const StepItem = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  minWidth: '120px',
});

const StepCircle = styled('div', ({ $active, $theme }: { $active: boolean; $theme: CustomTheme }) => ({
  width: '40px',
  height: '40px',
  borderRadius: '50%',
  background: $active ? $theme.colors['background.selected.bold'] : $theme.colors['background.accent.neutral.subtler'],
  color: $active ? $theme.colors['text.inverse'] : $theme.colors['text.primary'],
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: 400,
  fontSize: '16px',
  marginBottom: '8px',
}));

const StepLabel = styled('div', ({ $active, $theme }: { $active: boolean; $theme: CustomTheme }) => ({
  color: $active ? $theme.colors['text.primary'] : $theme.colors['text.secondary'],
  fontWeight: 500,
  fontSize: '14px',
  textAlign: 'center',
}));

const StepUnderline = styled('div', ({ $active, $theme }: { $active: boolean; $theme: CustomTheme }) => ({
  marginTop: '20px',
  width: '68px',
  height: '2px',
  background: $active ? $theme.colors['background.selected.bold'] : $theme.colors['background.accent.neutral.subtler'],
  borderRadius: '1.5px',
}));

export const Stepper = ({ current }: { current: number }) => {
  const [css, theme] = useStyletron();
  const steps = ['Upload Data', 'Review & Edit Schema', 'AI Builds Graph', 'View Results'];
  return (
    <StepperContainer>
      {steps.map((label, idx) => {
        const active = current === idx;
        const finished = current > idx;
        const underlineActive = current > idx;
        return (
          <React.Fragment key={`${label}-${idx}-fragment`}>
            <StepItem key={`${label}-${idx}`}>
              <StepCircle $active={active || finished} $theme={theme}>
                {finished ? <Check size={28} /> : idx + 1}
              </StepCircle>
              <StepLabel $active={active} $theme={theme}>
                {label}
              </StepLabel>
            </StepItem>
            {idx !== steps.length - 1 && (
              <StepUnderline key={`${label}-${idx}-underline`} $active={underlineActive} $theme={theme} />
            )}
          </React.Fragment>
        );
      })}
    </StepperContainer>
  );
};
